export const WARDENCLYFFE_TIMESTAMP_FORMAT = "yyyy-MM-dd";
